import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";

const PatientDetailsNoValue = () => (
  <span className="PatientDetailsNoValue">{translate(STRINGS.NONE)}</span>
);

export default PatientDetailsNoValue;
